import { Content } from '@backstage/core-components';
import {
  createFrontendModule,
  PluginHeaderActionBlueprint,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import { UserNotificationSettingsCard } from '@backstage/plugin-notifications';
import { IncidentPushSettings } from '@internal/backstage-plugin-platform-pipeline';
import { ButtonLink } from '@backstage/ui';
import SettingsIcon from '@material-ui/icons/Settings';

/** Where the panel lives: a tab of the user settings page. */
export const NOTIFICATION_SETTINGS_PATH = '/settings/notifications';

/** Senders, by the backend plugin that sends (the service principal of the notification). */
export const ORIGIN_NAMES: Record<string, string> = {
  'plugin:platform-orchestrator': 'Envs, pipelines et GitHub',
  'plugin:delivery': 'Jira et versions',
  'plugin:scaffolder': 'Création de composants',
};

/**
 * Labels of the topic ids the plugins send (TOPICS in DevNotifier.ts, JiraAssignmentNotifier.ts).
 * The ids are what the notification list shows and what the user's choice is stored under: they
 * stay as they are, only this panel gets clearer names.
 */
export const TOPIC_NAMES: Record<string, string> = {
  'Ephemeral environments':
    'Environnements éphémères (prêt, échec, expiration)',
  Pipelines: 'Pipelines Backstage en échec',
  GitHub: 'GitHub : tests E2E en échec',
  'Revues de code': 'GitHub : review demandée',
  'Mes PR': 'GitHub : mes PR (review, CI, conflit)',
  'Résumé du matin': 'Résumé du matin',
  'Incidents plateforme': 'Incidents plateforme : CI ou envs éphémères cassés',
  Jira: 'Jira : ticket du sprint assigné',
};

export function NotificationSettings() {
  return (
    <UserNotificationSettingsCard
      originNames={ORIGIN_NAMES}
      topicNames={TOPIC_NAMES}
    />
  );
}

/** Settings tab « Notifications »: turn each kind of notification on or off (IDP-18). */
export const notificationSettingsPage = SubPageBlueprint.make({
  name: 'settings',
  // A tab of the user settings page, which belongs to another plugin.
  attachTo: { id: 'page:user-settings', input: 'pages' },
  params: {
    path: 'notifications',
    title: 'Notifications',
    loader: async () => (
      <Content>
        <IncidentPushSettings />
        <NotificationSettings />
      </Content>
    ),
  },
});

/** « Paramètres » button in the header of the notifications page, next to the list it filters. */
export const settingsHeaderAction = PluginHeaderActionBlueprint.make({
  name: 'settings',
  params: {
    loader: async () => (
      <ButtonLink
        href={NOTIFICATION_SETTINGS_PATH}
        variant="secondary"
        size="small"
        iconStart={<SettingsIcon fontSize="small" />}
      >
        Paramètres
      </ButtonLink>
    ),
  },
});

export const notificationSettingsModule = createFrontendModule({
  pluginId: 'notifications',
  extensions: [notificationSettingsPage, settingsHeaderAction],
});
